import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Logo from '../UI/Logo/Logo';
import Button from '../UI/Button/Button';
import HrText from '../UI/HrText/HrText';
import strings from '../../assets/localization';
import classes from './IndexMain.module.css';
import classes2 from '../Auth/LoginModal/LoginModal.module.css';
import UrlLink from '../UI/UrlLink/UrlLink';
import FeatureIcons from './FeatureIcons/FeatureIcons';
import paths from '../../constants/paths';
import AppleLoginContainer from '../../containers/Auth/AppleLogin/AppleLoginContainer';
import AlertError from '../Auth/AlertError/AlertError';
import ScrollDownButton from './ScrollDownButton/ScrollDownButton';
import avatar from '../../assets/images/avatar/user-placeholder-gender-one.webp';
import Auxi from '../../hoc/Auxi/Auxi';
import Modal from '../UI/Modal/Modal';
import ModalScroll from '../UI/ModalScroll/ModalScroll';
import Spinner from '../UI/Spinner/Spinner';
import LanguageSwitch from '../../containers/LanguageSwitch/LanguageSwitchContainer';
import config from '../../constants/config';
import { isFirefox, isChrome, isIOS } from 'react-device-detect';

import CreateAccountInline from '../../containers/Auth/CreateAccountInline/CreateAccountInlineContainer';
import OneClickContainer from '../../containers/Auth/OneClick/OneClickContainer';
import HiddenNavBar from './HiddenNavBar/HiddenNavBar';
import {
  isAlternateAuthAvailable,
  parseGenderAndSeekingFromUrl,
  getGenderIdBasedOnGendersConfig,
} from '../../assets/helpers/utils';

// http://localhost:3000?oneclick=eyJzeXN0ZW0iOiJEVklQIiwiZG9tYWluIjoid3d3Lm1lZXRsb2NhbGJpa2Vycy5jb20iLCJjc3VtIjoiYTFjMjAxYTgwMGJiZjU4MzQxMjdjZGRhOTAzYzFjMGE5M2NjNjhlYiIsInVzZXJfaWQiOiIzMDExOTU5In0=
// http://localhost:3000?oneclick=eyJzeXN0ZW0iOiJEQkUiLCJkb21haW4iOiJzdGFnaW5nLmRhdGVhbWlsbGlvbmFpcmUuY29tIiwiY3N1bSI6ImY5NmI3ZTA0NGZhYjgwYjVhYzEzMTI5MGFlYWQ5ZjU1IiwidXNlcl9pZCI6IjEzMTU2NTc3In0=
let lastScrollY = 0;

class IndexMain extends Component {
  state = {
    showTopNavBar: false,
    mappedGendersFromUrl: null,
  };

  genderAndSeeking = undefined;
  componentDidMount() {
    // console.log('IndexMain::: Component DID MOUNT', this.props.history);

    // Check if URL contains gender/seeking data on page load
    if (
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.search &&
      (this.props.history.location.search.includes('gender') ||
        this.props.history.location.search.includes('seeking'))
    ) {
      this.genderAndSeeking = parseGenderAndSeekingFromUrl(
        this.props.history.location.search
      );
      this.props.setUserCreateAccountData({
        areGendersPreselectedFromUrlData: true,
      });
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    // console.log('IndexMain::: Component DID update', this.props);

    // When getConfig is updated, check if we have matching gender & seeking
    if (prevProps.getConfig.isFetching && !this.props.getConfig.isFetching) {
      const configGenders =
        this.props.getConfig &&
        this.props.getConfig.response &&
        this.props.getConfig.response.genders_singular;

      if (
        this.genderAndSeeking &&
        this.genderAndSeeking.gender &&
        this.genderAndSeeking.seeking
      ) {
        let seekingGenderFromUrl = getGenderIdBasedOnGendersConfig(
          this.genderAndSeeking,
          configGenders
        );

        if (
          seekingGenderFromUrl &&
          seekingGenderFromUrl.gender &&
          seekingGenderFromUrl.seeking
        ) {
          this.props.setUserCreateAccountData({
            gender: seekingGenderFromUrl.gender,
            seeking: seekingGenderFromUrl.seeking,
            genderApiConfigDataLodaded: true,
          });
        } else {
          this.props.setUserCreateAccountData({
            genderApiConfigDataLodaded: true,
          });
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  toggleMinHeight = () => {
    this.setState({ minHeight: '100vh' });
  };
  scroll2Next = () => {
    this.nodeNext.scrollIntoView({
      alignToTop: true,
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  };
  scroll2Previous = () => {
    this.nodePrevious.scrollIntoView({
      alignToTop: true,
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  };
  handleScroll = () => {
    lastScrollY = window.scrollY;

    if (lastScrollY > 100) {
      this.state.showTopNavBar === false &&
        this.setState({ showTopNavBar: true });
    } else {
      this.state.showTopNavBar === true &&
        this.setState({ showTopNavBar: false });
    }
  };
  renderReactivateAccount = () => {
    return (
      <div className={classes2.ReactivateAccount}>
        <div className={classes2.TitleWrapper}>
          <div className={classes2.Title}>{strings.welcomeBack}!</div>
          <p className={classes2.Text}>{strings.prevYouDeactivYourAcc}.</p>
          <p className={classes2.Text}>
            <b>{strings.doUwantToReacYourAcc}?</b>
          </p>
        </div>
        <div className={classes2.ImageWrapper}>
          <img className={classes2.Img} src={avatar} alt='avatar' />
        </div>
        <div className={classes2.ButtonWrapper}>
          <Button
            style={{ marginBottom: '1rem' }}
            clicked={() => {
              this.props.loginWithApple(this.props.appleData, 1);
            }}
          >
            {strings.yesReactivateMyAcc}
          </Button>
          <Button btnType='Secondary' clicked={this.props.goBack}>
            {strings.noKeepDeactivated}
          </Button>
        </div>
      </div>
    );
  };
  renderSpinner = () => {
    return (
      <div className={classes.SpinnerWrapper}>
        <Spinner size='Tiny' />
      </div>
    );
  };

  renderCompanyInfo = () => {
    return (
      <div className={classes.FooterCompanyInfo}>
        <p>1127 Royal Palm Beach Blvd</p>
        <p>Suite 234</p>
        <p>Royal Palm Beach, FL 33411</p>
      </div>
    );
  };

  render() {
    let top, footer;
    const isMainstream = config.TYPE === 'mainstream';

    if (!this.props.isLandscape) {
      // MOBILE
      top = (
        <div
          ref={(nodePrevious) => {
            this.nodePrevious = nodePrevious;
          }}
          className={classes.TopWrapper}
        >
          <div className={classes.SixPartsBackground}>
            <div className={classes.SixPartsRow}>
              <div className={classes.FirstOfSix} />
              <div className={classes.SecondOfSix} />
            </div>
            <div className={classes.SixPartsRow}>
              <div className={classes.ThirdOfSix} />
              <div className={classes.FourthOfSix} />
            </div>
            <div className={classes.SixPartsRow}>
              <div className={classes.FifthOfSix} />
              <div className={classes.SixthOfSix} />
              <div className={classes.Gardient} />
            </div>
          </div>
          <div className={classes.ContentWrapper}>
            <div className={classes.LogoWrapper}>
              <div className={classes.LogoWhiteWrapper}>
                <div className={classes.LanguageSwitch}>
                  <LanguageSwitch />
                </div>
                <Logo
                  style={{
                    maxWidth: '7.5rem',
                    height: '2rem',
                    margin: '0 auto',
                    background: 'none',
                  }}
                />
                <Button
                  btnType='LogIn'
                  style={{
                    fontSize: '0.675rem',
                    position: 'absolute',
                    background: 'none',
                    color: 'var(--primary-color-text)',
                    fontWeight: '400',
                    top: '0.725rem',
                    right: '0',
                    width: 'auto',
                  }}
                  isLink
                  link={paths.LOGIN}
                >
                  {strings.LOGIN}
                </Button>
              </div>
            </div>
            {this.props.isOneClick ? (
              <OneClickContainer
                history={this.props.history}
                isLandscape={this.props.isLandscape}
              />
            ) : (
              <CreateAccountInline
                innitialGoToStep={1}
                isLandscape={this.props.isLandscape}
                toggleMinHeight={this.toggleMinHeight}
                genderNewDefault={
                  config.GENDER_OTHER || config.GENDER_CONFIG_ORDER
                    ? config.NEW_GENDER
                    : 2
                }
                seekingNewDefault={
                  config.GENDER_OTHER || config.GENDER_CONFIG_ORDER
                    ? config.NEW_SEEKING
                    : 1
                }
                history={this.props.history}
              />
            )}
            <div className={classes.ToSPP}>
              <p className={[classes.TextWrapper]}>
                {strings.byCreatingYourAccount}
                <UrlLink to={paths.PRIVACY_POLICY}>
                  {strings.PrivacyPolicy}
                </UrlLink>
                ,{' '}
                <UrlLink to={paths.CONTENT_POLICY}>
                  {strings.ContentPolicy}
                </UrlLink>
                {' ' + strings.and + ' '}
                <UrlLink to={paths.TERMS_OF_SERVICE}>
                  {strings.TermsOfService}
                </UrlLink>
                .
              </p>
              <p className={classes.TextWrapper}>
                {strings.alsoAgree}
                {'.'}
              </p>
              <p className={classes.TextWrapper}>
                {strings.picturesDisclaimer}
                {'.'}
              </p>
            </div>
          </div>
        </div>
      );
      footer = (
        <div className={classes.BottomWrapper}>
          <div className={classes.JoinTodayWrapper}>
            <div className={classes.BottomButtonWrapper}>
              <Button
                btnType='Email'
                style={{ position: 'relative' }}
                width='22'
                isLink
                link={paths.SIGNUP}
              >
                {strings.SignUpWithEmail}
              </Button>
              {isAlternateAuthAvailable(this.props.getConfig) ? (
                <HrText>{strings.or.toUpperCase()}</HrText>
              ) : null}
              <Fragment>
                <AppleLoginContainer style={{ marginBottom: '1rem' }} />
              </Fragment>
            </div>
            {this.props.showSpinner ? this.renderSpinner() : null}
          </div>
          <div className={classes.FooterWrapper}>
            <p>{strings.byCreatingYourAccount}</p>
            <UrlLink
              to={paths.TERMS_OF_SERVICE}
              style={{ display: 'inline', padding: '1rem', margin: '-1rem' }}
            >
              {strings.TermsOfService}
            </UrlLink>{' '}
            <UrlLink
              style={{ display: 'inline', padding: '1rem', margin: '-1rem' }}
              to={paths.CONTENT_POLICY}
            >
              {strings.ContentPolicy}
            </UrlLink>
            <span> {strings.and} </span>
            <UrlLink
              to={paths.PRIVACY_POLICY}
              style={{ display: 'inline', padding: '1rem', margin: '-1rem' }}
            >
              {strings.PrivacyPolicy}.
            </UrlLink>
            <p>{strings.alsoAgree}</p>
          </div>
          <div className={classes.ScrollTopButtonWrapper}>
            <ScrollDownButton clicked={this.scroll2Previous} />
          </div>
          <div className={classes.FooterLinks}>
            <div className={classes.FooterLinksWrapper}>
              <UrlLink to={paths.CONTACT_US} infotext>
                {strings.ContactUs}
              </UrlLink>
              <UrlLink to={paths.DATA_MANAGEMENT} infotext>
                {strings.dataManagement}
              </UrlLink>
              <UrlLink to={paths.ANTI_HUMAN_TRAFFICKING_POLICY} infotext>
                {strings.AntiHumanTraffickingPolicy}
              </UrlLink>
              <UrlLink to={paths.CONTENT_POLICY} infotext>
                {strings.ContentPolicy}
              </UrlLink>
            </div>
            {isMainstream && this.renderCompanyInfo()}
          </div>
        </div>
      );
    } else {
      // DESKTOP
      top = (
        <div
          ref={(nodePrevious) => {
            this.nodePrevious = nodePrevious;
          }}
          className={classes.TopWrapper}
        >
          <div className={classes.ThreePartsBackground}>
            <div className={classes.BackgroundFirst} />
            <div className={classes.BackgroundSecond}>
              <div className={classes.Gardient} />
            </div>
            <div className={classes.BackgroundThird} />
          </div>
          <div className={classes.LogoWrapper}>
            <div className={classes.LogoWhiteWrapper}>
              <div className={classes.LanguageSwitch}>
                <LanguageSwitch />
              </div>
              <Logo
                style={{ margin: '0 auto', width: '50%', background: 'none' }}
              />
              <Button
                btnType='LogIn'
                style={{
                  fontSize: '0.75rem',
                  position: 'absolute',
                  background: 'none',
                  color: 'var(--primary-color-text)',
                  fontWeight: '400',
                  top: '2.25rem',
                  right: '1rem',
                  width: 'auto',
                }}
                isLink
                link={paths.LOGIN}
              >
                {strings.LOGIN}
              </Button>
            </div>
          </div>
          {this.props.isOneClick ? (
            <OneClickContainer
              history={this.props.history}
              isLandscape={this.props.isLandscape}
            />
          ) : (
            <CreateAccountInline
              innitialGoToStep={1}
              isLandscape={this.props.isLandscape}
              genderNewDefault={
                config.GENDER_OTHER || config.GENDER_CONFIG_ORDER
                  ? config.NEW_GENDER
                  : 2
              }
              seekingNewDefault={
                config.GENDER_OTHER || config.GENDER_CONFIG_ORDER
                  ? config.NEW_SEEKING
                  : 1
              }
              history={this.props.history}
            />
          )}
          <div className={classes.ToSPP}>
            <p className={[classes.TextWrapper]}>
              {strings.byCreatingYourAccount}
              <UrlLink to={paths.PRIVACY_POLICY}>
                {strings.PrivacyPolicy}
              </UrlLink>
              ,{' '}
              <UrlLink to={paths.CONTENT_POLICY}>
                {strings.ContentPolicy}
              </UrlLink>
              {' ' + strings.and + ' '}
              <UrlLink to={paths.TERMS_OF_SERVICE}>
                {strings.TermsOfService}
              </UrlLink>
              .
            </p>
            <p className={classes.TextWrapper}>
              {strings.alsoAgree}
              {'.'}
            </p>
            <p className={classes.TextWrapper}>
              {strings.picturesDisclaimer}
              {'.'}
            </p>
          </div>
        </div>
      );
      footer = (
        <div className={classes.BottomWrapper}>
          <div className={classes.JoinTodayWrapper}>
            <div className={classes.SignUpWrapper}>
              <Button
                btnType='Email'
                style={{ position: 'relative' }}
                width='22'
                isLink
                link={paths.SIGNUP}
              >
                {strings.SignUpWithEmail}
              </Button>
              <AppleLoginContainer
                style={{
                  position: 'relative',
                  marginLeft: '1rem',
                  width: '22%',
                }}
              />
            </div>
            {this.props.showSpinner ? this.renderSpinner() : null}
          </div>
          <div className={classes.FooterLinks}>
            <div
              className={
                isMainstream
                  ? classes.FooterLinksWrapperColumn
                  : classes.FooterLinksWrapperRow
              }
            >
              <UrlLink to={paths.CONTACT_US} infotext>
                {strings.ContactUs}
              </UrlLink>
              <UrlLink to={paths.CONTENT_POLICY} infotext>
                {strings.ContentPolicy}
              </UrlLink>
              <UrlLink to={paths.ANTI_HUMAN_TRAFFICKING_POLICY} infotext>
                {strings.AntiHumanTraffickingPolicy}
              </UrlLink>
              <UrlLink to={paths.DATA_MANAGEMENT} infotext>
                {strings.dataManagement}
              </UrlLink>
              <UrlLink to={paths.TERMS_OF_SERVICE} infotext>
                {strings.TermsOfService}
              </UrlLink>
              <UrlLink to={paths.PRIVACY_POLICY} infotext>
                {strings.PrivacyPolicy}
              </UrlLink>
            </div>
            {isMainstream && this.renderCompanyInfo()}
          </div>
        </div>
      );
    }

    return (
      // without scroll effect
      <div
        className={classes.IndexMain}
        style={{
          height:
            isFirefox || this.props.isLandscape
              ? '100%'
              : isIOS && isChrome
              ? '100vh'
              : 'calc( 100vh - var(--toolbarHeight))',
        }}
      >
        <HiddenNavBar
          gotoLogin={this.props.gotoLogin}
          style={{ display: this.state.showTopNavBar ? 'block' : 'none' }}
          isLandscape={this.props.isLandscape}
        />
        <p className={classes.Version}>v{config.VERSION}</p>
        <div style={{ position: 'relative' }}>{top}</div>
        {this.props.showReactivateModal ? (
          !this.props.isLandscape ? (
            <ModalScroll
              overflowDefault
              navbarCenterElement={strings.reactivateAccount}
            >
              {this.renderReactivateAccount()}
            </ModalScroll>
          ) : (
            <Modal
              navbarCenterElement={strings.reactivateAccount}
              overflowDefault
            >
              {this.renderReactivateAccount()}
            </Modal>
          )
        ) : (
          <Auxi>
            <div
              ref={(nodeNext) => {
                this.nodeNext = nodeNext;
              }}
              className={classes.SectionTwoWrapper}
            >
              <div className={classes.TitleLandingWrapper}>
                <h2>{strings.TitleLanding}</h2>
                <h3>{strings.SubTitleLanding}</h3>
              </div>
              <div className={classes.FeaturesWrapper}>
                <FeatureIcons />
              </div>
              {footer}
              {this.props.showErrorAlert ? (
                <AlertError
                  dismissAlert={this.props.dismissAlert}
                  errorMessage={this.props.errorAlertMessage}
                  btnTxt={this.props.accountStatus ? strings.Ok : false}
                />
              ) : null}
            </div>
          </Auxi>
        )}
      </div>
    );
  }
}

IndexMain.propTypes = {
  isLandscape: PropTypes.bool.isRequired,
};

export default IndexMain;
